import { createReducer, on } from '@ngrx/store';
import * as SuperEditActions from './user-settings.action';
import { UserSettings } from './user-settings.action';

export const initialState: UserSettings = {
  superEditMode: false,
  devMode: localStorage.getItem('devMode') === 'true',
  supportMode: localStorage.getItem('supportMode') === 'true',
  showHiddenFields: localStorage.getItem('showHiddenFields') === 'true',
};
/**
 * Reducer for the State of the Super-Edit Mode. Also persists the state into the localStorage.
 */
export const userSettingsReducer = createReducer(
  initialState,
  on(SuperEditActions.setSuperEditMode, (_state, props) => {
    return { ..._state, superEditMode: props.superEditMode };
  }),
  on(SuperEditActions.setDevMode, (_state, props) => {
    localStorage.setItem('devMode', `${props.devMode}`);
    return { ..._state, devMode: props.devMode };
  }),
  on(SuperEditActions.setSupportMode, (_state, props) => {
    localStorage.setItem('supportMode', `${props.supportMode}`);
    return { ..._state, supportMode: props.supportMode };
  }),
  on(SuperEditActions.setHiddenFieldsMode, (_state, props) => {
    localStorage.setItem('showHiddenFields', `${props.showHiddenFields}`);
    return { ..._state, showHiddenFields: props.showHiddenFields };
  }),
  on(SuperEditActions.initUserSettings, (_state) => {
    return {
      ..._state,
      devMode: localStorage.getItem('devMode') === 'true',
      supportMode: localStorage.getItem('supportMode') === 'true'
    };
  })
);
